import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AccountProvider } from '../account/AccountContext';
import { useSession } from './SessionContext';

export default function RequireSession() {
  const { session } = useSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  return (
    <AccountProvider>
      <Outlet />
    </AccountProvider>
  );
}
